import { CustomHandler } from "@crescentParts/Store/CustomHandlerCreator";
import { createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { GetProductCollectionApiV2Parameter, GetRelatedProductCollectionApiV2Parameter, getRelatedProductsCollectionV2 } from "@insite/client-framework/Services/ProductServiceV2";
import { ProductCollectionModel, ProductModel } from "@insite/client-framework/Types/ApiModels";

type Parameter = {
    modalIsOpen: boolean;
    productId: string;
};

type HandlerType = CustomHandler<Parameter>

export const DispatchCompleteSetRelatedProductsModalIsOpen: HandlerType = props => {
    props.dispatch({
        type: "Custom/RelatedProductsModal/CompleteSetIsOpen",
        modalIsOpen: props.parameter.modalIsOpen,
        productId: props.parameter.productId,
    });
};

export const chain = [DispatchCompleteSetRelatedProductsModalIsOpen];

const setRelatedProductsModalIsOpen = createHandlerChainRunner(chain, "SetRelatedProductsModalIsOpen");
export default setRelatedProductsModalIsOpen;
